// Debug utility for authentication
export const debugAuthResponse = (response) => {
  console.log('🔍 AUTH DEBUG: Login response received');
  console.log('Full response:', response);
  console.log('User object:', response.user);
  console.log('User roles:', response.user?.roles);
  console.log('User type:', response.userType);
  console.log('Tenants:', response.tenants);
  console.log('Default tenant:', response.defaultTenant);
};

export const debugUserState = (user) => {
  console.log('🔍 AUTH DEBUG: Current user state');
  console.log('User object:', user);
  console.log('User roles:', user?.roles);
  console.log('User type:', user?.userType);
  console.log('Is admin:', user?.isAdmin);
  console.log('Is super admin:', user?.isSuperAdmin);
};

export const debugRoleCheck = (user, role) => {
  console.log('🔍 AUTH DEBUG: Role check');
  console.log('Checking role:', role);
  console.log('User roles:', user?.roles);
  console.log('Has role:', user?.roles?.some(r => r.RoleName === role));
};
